import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import SideNav from '../../SideNav'
import classNames from '../../../utils/classNames'
import Metadata from '../../Metadata'

const Main = () => {
  const [sidebarCollapse, setSideBarCollapse] = useState(true)

  const defaultMetadata = {
    title: 'Safelto Dashboard',
    description: 'Safelto dashboard - Manage your estate efficiently with our comprehensive property management platform.',
    keywords: ['dashboard', 'estate management', 'property management', 'resident management', 'security', 'maintenance'],
    image: '/assets/images/safelto-big.png',
    url: 'https://safelto.com/dashboard',
    type: 'website' as 'website'
  }

  const toggleSidebar = () => {
    setSideBarCollapse((prev) => !prev)
  }

  return (
    <>
      <Metadata {...defaultMetadata} />
      <SideNav collapsed={sidebarCollapse} toggle={toggleSidebar} />
      <div
        className={classNames([
          'w-full transition-all duration-500',
          {
            'pl-[260px]': !sidebarCollapse,
            'pl-[70px]': sidebarCollapse,
          },
        ])}
      >
        <Outlet />
      </div>
    </>
  )
}

export default Main